const ServiceFee = 0.25;
export default ServiceFee;
